import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronUp_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5303 14.0303C17.2374 14.3232 16.7626 14.3232 16.4697 14.0303L10 7.56066L3.53033 14.0303C3.23744 14.3232 2.76256 14.3232 2.46967 14.0303C2.17678 13.7374 2.17678 13.2626 2.46967 12.9697L9.46967 5.96967C9.76256 5.67678 10.2374 5.67678 10.5303 5.96967L17.5303 12.9697C17.8232 13.2626 17.8232 13.7374 17.5303 14.0303Z"
            />
        </SvgStyled>
    );
};

export default ChevronUp_sm;
